import { render } from "./CallRosterPanel.vue.js?vue&type=template&id=4482a85b!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRosterPanel.vue?vue&type=template&id=4482a85b"
import script from "./CallRosterPanel.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRosterPanel.vue?vue&type=script&lang=js"
export * from "./CallRosterPanel.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRosterPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/roster/CallRosterPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4482a85b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4482a85b', __exports__)) {
    api.reload('4482a85b', __exports__)
  }
  
  module.hot.accept("./CallRosterPanel.vue.js?vue&type=template&id=4482a85b!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRosterPanel.vue?vue&type=template&id=4482a85b", () => {
    api.rerender('4482a85b', render)
  })

}


export default __exports__